export default {
  switchToMeaning: 'Przełącz na znaczenie',
};
